import { ScheduledConsultationTypeDTO, type ScheduledConsultationDTO } from '@/generated'
import router from '@/router/router'
import { routeNames } from '@/router/routeNames'

const formatToICalDate = (dateStr: string): string => {
  const date = new Date(dateStr)
  return date.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z'
}

const escapeText = (text?: string): string => {
  if (!text) return ''
  return text.replace(/[\\,;]/g, (match) => `\\${match}`).replace(/\n/g, '\\n')
}

const buildDescription = (consultation: ScheduledConsultationDTO, t: any): string => {
  const lines: string[] = []

  switch (consultation.type) {
    case ScheduledConsultationTypeDTO.CONFERENCE:
      if (consultation.conferenceTopic) {
        lines.push(consultation.conferenceTopic)
      }
      if (consultation.conferenceDescription) {
        lines.push(consultation.conferenceDescription)
      }
      break

    case ScheduledConsultationTypeDTO.PATIENT_PRESENTATION:
      if (consultation.patientPresentationMedicalHistory)
        lines.push(`${t('Medical History')}: ${consultation.patientPresentationMedicalHistory}`)
      if (consultation.patientPresentationDiagnosis)
        lines.push(`${t('Diagnosis')}: ${consultation.patientPresentationDiagnosis}`)
      break

    case ScheduledConsultationTypeDTO.PATIENT_VISIT:
      break
  }

  return escapeText(lines.join('\n\n'))
}

export const downloadConsultationICal = (
  consultation: ScheduledConsultationDTO,
  translatedType: string,
  t: any
) => {
  const start = formatToICalDate(consultation.scheduledStartTime)
  const end = formatToICalDate(consultation.scheduledEndTime)
  const appUrl = `${window.location.origin}${router.resolve({ name: routeNames.CONSULTATION_DETAILS, params: { consultationId: consultation.id } }).href}`

  const summary =
    consultation.type === ScheduledConsultationTypeDTO.CONFERENCE && consultation.conferenceTopic
      ? `${translatedType}: ${consultation.conferenceTopic}`
      : translatedType

  const icsLines = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//elmo//ConsultationExport//EN',
    'CALSCALE:GREGORIAN',
    'BEGIN:VEVENT',
    `DTSTAMP:${formatToICalDate(new Date().toISOString())}`,
    `UID:${consultation.id}`,
    `DTSTART:${start}`,
    `DTEND:${end}`,
    `SUMMARY:${escapeText(summary)}`,
    `DESCRIPTION:${buildDescription(consultation, t)}`,
    `LOCATION:${appUrl}`,
    'STATUS:CONFIRMED',
    'END:VEVENT',
    'END:VCALENDAR'
  ]

  const blob = new Blob([icsLines.join('\r\n')], { type: 'text/calendar;charset=utf-8' })
  const link = document.createElement('a')
  link.href = window.URL.createObjectURL(blob)
  link.setAttribute('download', `${translatedType}-${consultation.id}.ics`)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
